module.exports = __webpack_public_path__ + "img/16-l.76d270d8.png";